import React from 'react';
import './PageBody.scss';

function PageBody({ children }) {
  return <div className="ivia-website-body">{children}</div>;
}

export default PageBody;
